import { createContext } from "react";

import { MaintenanceMode, defaultMaintenanceMode } from "./maintenance-mode-model.context.lib";

export const MaintenanceModeContext = createContext<MaintenanceMode>(defaultMaintenanceMode);
